// client/src/lib/deviceId.ts
const STORAGE_KEY = 'deviceId'

export function getOrCreateDeviceId(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY)
    if (existing) return existing

    const id = crypto.randomUUID()
    localStorage.setItem(STORAGE_KEY, id)
    return id
  } catch {
    // localStorage indisponible (navigation privée stricte, etc.) : on
    // génère un id éphémère plutôt que de faire planter l'inscription.
    return crypto.randomUUID()
  }
}
